<template>
  <div id="insider-backtester-exit-rules-tab">
    <v-container fluid pa-0>
      <v-row>
        <!-- When to exit out of a position -->
        <v-col cols="12">
          <helpers-section-sub-header>When to exit out of a position:</helpers-section-sub-header>

          <!-- Stop Loss Exit % -->
          <v-row>
            <v-col cols="12" sm="6" md="4" xl="3" class="align-end d-flex">
              <v-checkbox
                v-model="criteria.exit_stop_loss_enabled"
                hide-details
                class="mb-1 mt-0 mr-2"
                style=""
              />
              <v-text-field
                v-model="criteria.exit_stop_loss"
                :disabled="!criteria.exit_stop_loss_enabled"
                type="number"
                suffix="%"
                label="Stop loss exit %"
                hide-details
              />
            </v-col>
          </v-row>

          <!-- Stop Gain Exit % -->
          <v-row>
            <v-col cols="12" sm="6" md="4" xl="3" class="align-end d-flex">
              <v-checkbox
                v-model="criteria.exit_stop_gain_enabled"
                hide-details
                class="mb-1 mt-0 mr-2"
                style=""
              />
              <v-text-field
                v-model="criteria.exit_stop_gain"
                :disabled="!criteria.exit_stop_gain_enabled"
                type="number"
                suffix="%"
                label="Stop gain exit %"
                hide-details
              />
            </v-col>
          </v-row>

          <!-- Exit Max Time Held in Days -->
          <v-row>
            <v-col cols="12" sm="6" md="4" xl="3" class="align-end d-flex">
              <v-checkbox
                v-model="criteria.exit_elapsed_time_enabled"
                hide-details
                class="mb-1 mt-0 mr-2"
              />
              <v-text-field
                v-model="criteria.exit_elapsed_time"
                :disabled="!criteria.exit_elapsed_time_enabled"
                type="number"
                suffix="days"
                label="Exit max time held in days"
                hide-details
              />
            </v-col>
          </v-row>
        </v-col>

        <!-- Enable hold until profitable or fully invested -->
        <v-col cols="12" class="mb-2">
          <p>
            Below rule is optional: If NOT fully invested and the Exit Max Time In Days limit is
            reached and the position is profitable, exit the position, else hold until profitable or
            account becomes fully invested.
          </p>
          <p>
            The idea is to give positions a chance to work as long as there are no capital
            requirements needed to make new entries.
          </p>
          <v-checkbox
            v-model="criteria.hold_until_profit_or_fully_invested"
            :disabled="!criteria.exit_elapsed_time_enabled"
            label="Enable hold until profitable or fully invested"
            hide-details
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  computed: {
    ...mapFields({
      criteria: 'app.insiderBacktesterCriteria'
    })
  }
}
</script>
